'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _dekuTabs = require('@viskan/deku-tabs');

var _dekuTabs2 = _interopRequireDefault(_dekuTabs);

var _dekuAccordion = require('@viskan/deku-accordion');

var _dekuAccordion2 = _interopRequireDefault(_dekuAccordion);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var getItems = function getItems(_ref, items) {
	var accordionOnMobile = _ref.accordionOnMobile,
	    accordionOnTablet = _ref.accordionOnTablet,
	    accordionOnDesktop = _ref.accordionOnDesktop,
	    breakpoint = _ref.breakpoint,
	    keepTabsOpen = _ref.keepTabsOpen,
	    spaceTabsEvenly = _ref.spaceTabsEvenly,
	    styleClasses = _ref.styleClasses;

	var breakp = breakpoint.breakpointOverride ? breakpoint.breakpointOverride : breakpoint.breakpoint;

	switch (breakp) {
		case 'xsm':
			if (accordionOnMobile) {
				return (0, _magicVirtualElement2.default)(_dekuAccordion2.default, { styleClasses: styleClasses, items: items, multiple: keepTabsOpen });
			}
			break;
		case 'sm':
			if (accordionOnMobile) {
				return (0, _magicVirtualElement2.default)(_dekuAccordion2.default, { styleClasses: styleClasses, items: items, multiple: keepTabsOpen });
			}
			break;
		case 'md':
			if (accordionOnTablet) {
				return (0, _magicVirtualElement2.default)(_dekuAccordion2.default, { styleClasses: styleClasses, items: items, multiple: keepTabsOpen });
			}
			break;
		default:
			if (accordionOnDesktop) {
				return (0, _magicVirtualElement2.default)(_dekuAccordion2.default, { styleClasses: styleClasses, items: items, multiple: keepTabsOpen });
			}
	}

	return (0, _magicVirtualElement2.default)(_dekuTabs2.default, { styleClasses: styleClasses, items: items, 'class': spaceTabsEvenly && 'StretchTabs' });
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var children = props.children;

	var items = children.map(function (x) {
		return {
			heading: x.attributes.heading,
			content: x,
			identifier: x.attributes.identifier
		};
	});

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-TabsContainer', props.class, props.styleClasses.Tabs_Container], 'data-style-attr': 'Tabs_Container' },
		getItems(props, items)
	), props);
};

exports.default = { render: render };